import { DownloadK8sAgentGzDataProvider } from '../dataProvider/DownloadK8sAgentGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class DownloadK8sAgentDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, DownloadK8sAgentGzDataProvider);
  }
}
